import Link from "next/link"
import { Icon } from '../atoms';
import styles from './more-button.module.scss';
import { FC } from "react";

type MoreButtonProps = {
  children: React.ReactNode;
  url: URL;
}

export const MoreButton: FC<MoreButtonProps> = ({ children, url }) => {
  return (
    <Link href={url.toString()} className={styles.moreButton}>
      <span>{children}</span>
      <Icon icon="link-arrow" size={'20px'} color={'var(--primary-color)'} />
    </Link>
  )
}
